<template lang="pug">
  div
    section.content-header
      h1 ユーザー情報のインポート
      ol.breadcrumb
        li
          router-link(:to="{name: 'admin'}")
            i.fa.fa-cog
            | システム管理
        li
          router-link(:to="{name: 'user'}") ユーザー管理
        li.active ユーザー情報のインポート

    section.content

      form(ref="form", @submit.prevent="postData(true)", novalidate)
        mixin btnbar
          .bcard-btnbar.clearfix.text-left(class!=attributes.class)
            router-link.btn.btn-default(:to="{name:'user'}" title="戻る"): i.fa.fa-reply
            |
            |
            button.btn.btn-primary(v-if="isUploadAvailable" type="submit") インポート

        +btnbar

        app-messages(
          :errorMessages="errors", :errorTitleMessage="errorTitle",
          :successMessages="successes", :successTitleMessage="successTitle",
          :infoMessages="messages", :infoIconClass="'icon fa fa-spinner fa-pulse'", :infoTitleMessage="infoTitle",
        )

        //- ロック中は表示しない
        div(v-if="isUploadAvailable")
          .box.box-widget
            .box-header.with-border
              .box-title 項目の順番
            .box-body
              .form-group
                .bcard-btnbar
                  button.btn.btn-default(type="button" @click.prevent="resetImexfld") 既定値に戻す
                .table-responsive.bcard-table-container
                  table.table.table-bordered.table-hover
                    draggable(v-model="imexfld", element="tbody", :options="{draggable:'.item'}")
                      tr.item(v-for="fld in imexfld", :key="fld.value")
                        td
                          input.form-control(type="hidden", name="imexfld[]", :value="fld.value")
                          i.fa.bcard-fa-grip
                          | &nbsp;{{fld.name}}
                      tr
                        td
                          | 所属組織

          .box.box-widget
            .box-body
              .form-horizontal
                import-settings(v-model="importSettings", ref="importSettings")
              p.bcard-required ※ (*)は必須項目です。

        +btnbar

      .callout.callout-info.bcard-callout
        p
          | ※ 行単位にエラーチェックを行い、エラーがなければ登録されます。
          br
          | ※ エラーがあった場合
          br
          | &emsp; エラーがあった行以降は登録処理は行われません。
          br
          | &emsp; CSVファイルからエラーがあった行の前行までを削除し、エラー内容を修正の上、もう一度インポートしてください。
          br
          | ※ インポートする項目の順番をドラッグ＆ドロップで変更できます。
          br
          | ※ 変更した項目の順番は保存され、エクスポートの項目の順番も同様となります。
          br
          | ※ 削除する場合、「削除フラグ」には“d”または“D”を指定してください。
          br
          | &emsp; ユーザーを削除すると、“削除済み”となります。
          br
          | &emsp; 削除済みのユーザーは[ユーザー情報の変更]から[データベースから削除]を行った場合、完全に削除されます。
          br
          | ※ ユーザー情報を新規に追加する場合、「ID」には“0”を指定してください。
          br
          | ※ 既に登録されているデータの上書きを行う場合、「ID」には上書きするデータの「ID」を指定してください。
          br
          | &emsp; (登録済みIDの値は、エクスポートでCSVファイルに出力してご確認ください。)
          br
          | ※ パスワードの文字がすべて“*(アスタリスク)”の場合(何文字でも可)、パスワードの変更は行いません。
          br
          | ※ 「ログインID」を指定する場合、ほかのユーザーと重複しないIDを指定してください。
          br
          | &emsp; 「ログインID」が重複した場合インポートできません。
          br
          | ※ 「ユーザーレベル」に“管理者”を指定した場合は“システム管理者”、“管理者”以外を指定した場合は“一般ユーザー”として設定されます。
          br
          | ※ 「名刺エクスポート可能フラグ」に“可”を指定した場合は“可”、“可”以外を指定した場合は“不可”として設定されます。
          br
          | ※ 「使用停止フラグ」に”使用停止”を指定した場合は”使用停止ユーザー”として設定されます。
          br
          | ※ 「所属組織」は複数指定できます。先頭の所属組織が代表組織となります。
          br
          | ※ 「所属組織」に指定したい組織が登録されていない場合は、[組織の追加]を先に行ってください。
          br
          | ※ 「所属組織」は以下のいずれかを指定してください。
          br
          | ・ “*(アスタリスク)” + 「組織システムID」 (例 : *246)
          br
          | ・ “@(アットマーク)” + 「企業内組織コード」 (例 : @NEO0001)
          br
          | ・ 「組織名」(例 : 情報システム室)
          br

</template>

<script>
import draggable from 'vuedraggable'
import mixinImportExport from '@/mixins/importExport'
import AppMessages from '@/components/molecules/AppMessages'
import ImportSettings from '@/components/organisms/ImportSettings'
import mixinForm from '@/mixins/form'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const UserRepository = RepositoryFactory.get('user')

export default {
  name: 'UserImport',
  components: { draggable, AppMessages, ImportSettings },
  mixins: [ mixinImportExport, mixinForm ],
  data: function () {
    return {
      imexfld: [], // 表示する項目の順番

      isUploadAvailable: false, // ロック中は使えないのでフラグを用意する
      importSettings: {
        csvFile: null
      },
      // 結果取得フラグ
      isGodResult: null, // 初期値：null, 取得完了：true, 取得中：false

      // インポートエラーモーダル
      modalImportErrMsg_isOpen: false,
      modalImportErrMsg_msgdetail: '',

      // app-message
      errorTitle: '',
      successTitle: '',
      infoTitle: ''
    }
  },
  created: function () {
    // 画面を初期化する
    this._initPage()
  },
  methods: {
    /**
     * 画面の初期化処理
     */
    _initPage: function () {
      this.infoTitle = 'インポート状況を確認しています。'
      this.messages.push('しばらくお待ちください。')

      // 処理結果取得
      this.getResult()
      // 項目の順番を設定する
      this.setImexfld()
    },
    /*
     * 項目の順番を設定する
     */
    setImexfld: function () {
      this.imexfld = this.comSetImexfld('user')
    },
    /*
     * 項目の順番を規定値に戻す
     */
    resetImexfld: function () {
      // imexfldの内容をpresetの値に置き換える
      this.imexfld = this.comSetImexfld('user', true)
    },
    /**
     * CSVファイルをインポートする
     * @param Boolean fromSubmit サブミットフラグ
     */
    postData: function (fromSubmit) {
      if (!this.checkFormValidity()) return

      const vm = this

      // 画面表示を早めに切り替えるため
      vm.clearMessages()
      vm.infoTitle = 'CSVファイルをインポート中です。'
      vm.messages.push('インポートには時間がかかることがあります。しばらく経ってからもう一度アクセスしてください。')

      // 続けてアップロードできないようにする
      vm.isUploadAvailable = false

      // 登録内容
      let userFormData = new FormData(this.$refs.form)

      // FileListからFileを削除するための苦肉の策
      userFormData = this.appendFiles(userFormData, true)

      // API実行
      UserRepository.import(userFormData, {
        headers: {'Content-Type': 'multipart/form-data'}
      })
        // 成功時処理
        .then(function (response) {
          if (vm.isApiSuccess(response)) {
            // 処理結果取得
            vm.getResult(fromSubmit)
          }
        })
        // システムエラー
        .catch(function (error) {
          // 別のファイルをインポートできるようにする
          vm.isUploadAvailable = true
          // メッセージ入れ替え
          vm.clearMessages()
          vm.setErrorMessage(error)
        })

      // ExportSettingsのsaveCookie()を呼び出す
      this.$refs.importSettings.$refs.exportSettings.saveCookie()
      // 項目の順番をCookieに保存する
      this.comSaveCookie('user', this.imexfld)

      window.scrollTo(0, 0)
    },
    /**
     * 前回のインポートの処理結果を取得する
     * @param Boolean fromSubmit サブミットフラグ
     */
    getResult: function (fromSubmit) {
      const vm = this
      const getResult = setInterval(function () {
        // 前回の結果取得が終わっていない場合、結果取得を行わない
        if (vm.isGodResult === false) {
          return
        }

        // 結果取得フラグをオフにする
        vm.isGodResult = false
        UserRepository.getImportResult()
          // 成功時処理
          .then(function (response) {
            const infoMessage = 'CSVファイルをインポート中です。'
            const successMessage = 'CSVファイルのインポートが完了しました。'
            const errorMessage = 'CSVファイルのインポートが完了しませんでした。'

            if (vm.isApiSuccess(response)) {
              let data = vm.getApiData(response)
              // インポート中の場合、次のファイルをインポートできないようにする
              vm.isUploadAvailable = (data.status !== 'active')
              if (vm.isUploadAvailable) {
                clearInterval(getResult)
              }

              // ガイドを表示
              vm.clearMessages()
              if (data.status === 'active') {
                vm.infoTitle = fromSubmit ? infoMessage : '前回アップロードした' + infoMessage
                vm.messages.push('インポートには時間がかかることがあります。しばらく経ってからもう一度アクセスしてください。')
              }
              else if (data.status === 'finish') {
                vm.successTitle = fromSubmit ? successMessage : '前回アップロードした' + successMessage
                vm.successes.push(data.message)
              }
            // アプリエラー
            }
            else {
              let data = vm.getApiData(response)
              // ガイドを表示
              vm.clearMessages()
              vm.errorTitle = fromSubmit ? errorMessage : '前回アップロードした' + errorMessage
              vm.errors = data.message.split('\n')
              vm.isUploadAvailable = true
              clearInterval(getResult)
            }
          })
          // システムエラー
          .catch(function (error) {
            // メッセージ入れ替え
            vm.clearMessages()
            vm.setErrorMessage(error)
            clearInterval(getResult)
          })
          .finally(function () {
            // 結果取得フラグをオンにする
            vm.isGodResult = true
          })
      }, this.app_interval.getResult)
      this.$store.commit('setIntervals', getResult)
    }
  }
}
</script>

<style lang="scss" scoped>
table {
  tr {
    &.item {
      cursor: move;
    }

    &:not(.item) {
      background-color: #ccc;
      opacity:.7;
      cursor: default;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/user/Import.vue